import { Container as MantineContainer, ContainerProps } from '@mantine/core';
import { forwardRef, useContext } from 'react';
import { LayoutManagedContext } from './layoutContext';

export interface ThemedContainerProps extends ContainerProps {
  centered?: boolean;
}

const Container = forwardRef<HTMLDivElement, ThemedContainerProps>(
  ({ centered = false, style, children, size, fluid, px, ...rest }, ref) => {
    // Inside a managed layout (MainLayout / DemoLayout via LayoutContainer), the
    // global Layout Preference (Content Width + Horizontal Padding from Settings)
    // already governs width + horizontal padding. So ignore this Container's own
    // size/fluid/px and span the managed area — every page conforms regardless of
    // its own wrapper.
    const managed = useContext(LayoutManagedContext);

    const centeredStyle = centered
      ? {
          display: 'flex',
          flexDirection: 'column' as const,
          alignItems: 'center',
          justifyContent: 'center',
        }
      : undefined;

    if (managed) {
      return (
        <MantineContainer
          ref={ref}
          fluid
          px={0}
          style={{ ...centeredStyle, ...style }}
          {...rest}
        >
          {children}
        </MantineContainer>
      );
    }

    return (
      <MantineContainer
        ref={ref}
        size={size}
        fluid={fluid}
        px={px}
        style={{ ...centeredStyle, ...style }}
        {...rest}
      >
        {children}
      </MantineContainer>
    );
  }
);

Container.displayName = 'Container';

export default Container;
